var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.119 0H2.88095C1.56667 0 0.5 1.06667 0.5 2.38095V17.619C0.5 18.9333 1.56667 20 2.88095 20H18.119C19.4333 20 20.5 18.9333 20.5 17.619V2.38095C20.5 1.06667 19.4333 0 18.119 0ZM6.69048 7.61905V16.6667H3.83333V7.61905H6.69048ZM3.83333 4.98571C3.83333 4.31905 4.40476 3.80952 5.2619 3.80952C6.11905 3.80952 6.65714 4.31905 6.69048 4.98571C6.69048 5.65238 6.15714 6.19048 5.2619 6.19048C4.40476 6.19048 3.83333 5.65238 3.83333 4.98571ZM17.1667 16.6667H14.3095C14.3095 16.6667 14.3095 12.2571 14.3095 11.9048C14.3095 10.9524 13.8333 10 12.6429 9.98095H12.6048C11.4524 9.98095 10.9762 10.9619 10.9762 11.9048C10.9762 12.3381 10.9762 16.6667 10.9762 16.6667H8.11905V7.61905H10.9762V8.83809C10.9762 8.83809 11.8952 7.61905 13.7429 7.61905C15.6333 7.61905 17.1667 8.91905 17.1667 11.5524V16.6667Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6166828e4e2fefd2e08d10c301215cd9.svg";
export { ForwardRef as ReactComponent };